export class PaymentMethodOption {
    constructor(public value: string, public text: string) {
    }
}